import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import Question from 'on_web/components/shared/Question/Question';
import CountriesSelect from 'on_web/components/shared/CountriesSelect/CountriesSelect';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';
import { getQuestionsEthnicity } from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';

export default function GeneralStep3(props) {
  const context = React.useContext(UserProfileContext);
  const [selectedEthnicity, setSelectedEthnicity] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.user_metadata.selectedEthnicity
      ? context.userMetaData.user_metadata.selectedEthnicity
      : undefined
  );
  const [zipCode, setZipCode] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.user_metadata.zipCode
      ? context.userMetaData.user_metadata.zipCode
      : ''
  );
  const [country, setCountry] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.user_metadata.country
      ? context.userMetaData.user_metadata.country
      : 'United States of America'
  );

  const { t } = useTranslation();

  const onClickNext = () => {
    const userMetaData = context ? context.userMetaData.user_metadata : null;

    if (props.onClickNext && userMetaData) {
      userMetaData.selectedEthnicity = selectedEthnicity;
      if (userMetaData.zipCode && zipCode === '') {
        delete userMetaData.zipCode;
      } else {
        userMetaData.zipCode = zipCode;
      }
      userMetaData.country = country;
      props.onClickNext(userMetaData);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {context && context.forPce ? (
        <PceStepProgressIndicator selectedSlideIx={1} />
      ) : (
        (context == null || context.editMode !== true) && (
          <StepProgressIndicator
            showBasicQuestions={context.showBasicQuestions}
            selectedSlideIx={
              process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 1 : 0
            }
          />
        )
      )}

      <Question
        sectionTitle={t('onboarding.generalSection.generalStep3.sectionTitle1')}
        radioSelection={{
          items: getQuestionsEthnicity(selectedEthnicity, t),
          twoColumns: true,
        }}
        onAnswer={val => setSelectedEthnicity(val)}
      />

      {(context == null || context.forPce !== true) && (
        <>
          <Question
            sectionTitle={t(
              'onboarding.generalSection.generalStep3.sectionTitle2'
            )}
            onAnswer={val => setZipCode(val)}
            textInput={true}
            textValue={zipCode}
            instructionAbove={t(
              'onboarding.generalSection.generalStep3.instructionAbove2'
            )}
          />

          <Box pb={4}>
            <Question
              prefixControls={[
                <CountriesSelect
                  country={country}
                  countrySelected={country => setCountry(country)}
                />,
              ]}
            />
          </Box>
        </>
      )}

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={selectedEthnicity == null}
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}
